import { createElement, memo } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import Image from '@max/leez-image';
import LinearGradient from '@hfe/max-linear-gradient';
import './ThreeColumnCard.scss';
import { buildReportData } from "../utils/report";
import { onNavigate } from '../utils/navigate';
import { getImage } from "../utils/common";
import { useMonitorEngineContext } from '@nibfe/mcp-monitor-sdk';
import Sensor from '@max/mbc-sensor';
import { BID } from '../const/bid';
function ThreeColumnCard(props) {
    const { productId, productIdStr, productName, productType, productTypeName, frontImg, displayTag, areaName, saveMoneyTag, soldInfo, actualPrice, averagePrice, originalPrice, buyText, extInfo, poiIdListString, poiIdUrlExtraParamsString, texReportData, topTagText, topTagShowCount = 0, cardIndex = 0 } = props;
    const ctx = useMonitorEngineContext();
    // 判断是否应该展示角标
    const shouldShowTopTag = topTagText && (topTagShowCount === 0 || cardIndex < topTagShowCount);
    const jumpToPage = (product, query, systemInfo) => {
        var _a, _b;
        (_b = (_a = ctx === null || ctx === void 0 ? void 0 : ctx._LXReport) === null || _a === void 0 ? void 0 : _a.mcReport) === null || _b === void 0 ? void 0 : _b.call(_a, BID.CARD_MC, {
            valLab: buildReportData(props)
        });
        onNavigate(product, query, systemInfo !== null && systemInfo !== void 0 ? systemInfo : {}, poiIdListString !== null && poiIdListString !== void 0 ? poiIdListString : '', poiIdUrlExtraParamsString !== null && poiIdUrlExtraParamsString !== void 0 ? poiIdUrlExtraParamsString : '');
    };
    return <Sensor onAppear={() => {
            var _a, _b;
            (_b = (_a = ctx === null || ctx === void 0 ? void 0 : ctx._LXReport) === null || _a === void 0 ? void 0 : _a.mvReport) === null || _b === void 0 ? void 0 : _b.call(_a, BID.CARD_MV, {
                valLab: buildReportData(props)
            });
        }}>
      <View className="three-column-card" onClick={() => {
            var _a, _b, _c;
            return jumpToPage({
                productType,
                productIdStr,
                extInfo
            }, {
                hotelchannel: (_c = (_b = (_a = ctx === null || ctx === void 0 ? void 0 : ctx._runtimeInfo) === null || _a === void 0 ? void 0 : _a.queryParams) === null || _b === void 0 ? void 0 : _b.hotelchannel) !== null && _c !== void 0 ? _c : '-999'
            }, {});
        }}>
        <View className="three-column-image-wrapper">
          <Image className="three-column-image" source={getImage(frontImg)} borderRadius={0} widthAuto heightAuto/>
          {shouldShowTopTag && <LinearGradient colors={['#FF9233', '#FF5500']} start={{
                x: 0,
                y: 0
            }} end={{
                x: 1,
                y: 0
            }} className="three-column-top-tag">
              <Text className="three-column-top-tag-text">{topTagText}</Text>
            </LinearGradient>}
          {areaName && <View className="three-column-location-overlay">
              <View className="three-column-location-icon-wrapper">
                <Image source={{
                uri: 'https://p0.meituan.net/ingee/dee934b5bbd3366f424f011758894a48308.png'
            }} style={{
                width: '17rpx',
                height: '21rpx'
            }}></Image>
              </View>
              <Text className="three-column-location-text" numberOfLines={1}>
                {areaName}
              </Text>
            </View>}
        </View>

        <View className="three-column-content">
          <Text className="three-column-name" style={{
            textOverflow: 'ellipsis'
        }} numberOfLines={2}>
            {productName}
          </Text>

          <View x-if={saveMoneyTag || soldInfo} className="three-column-tags" style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center'
        }}>
            <View x-if={saveMoneyTag} className="three-column-tag-item"><Text className="three-column-tag-item-text">{saveMoneyTag}</Text></View>
            {/* {saveMoneyTag && soldInfo && <Text className="three-column-tag-divider"> | </Text>} */}
            <View x-if={soldInfo} className="three-column-tag-item"><Text className="three-column-tag-item-text">已售{soldInfo}</Text></View>
          </View>

          <View className="three-column-bottom">
            <View className="three-column-price-wrapper">
              <Text>
                  <Text className="three-column-price-symbol">¥</Text>
                  <Text className="three-column-price" style={{
            fontSize: Number(actualPrice) > 1999 ? '24rpx' : '34rpx'
        }}>{actualPrice || averagePrice}</Text>
                  <Text x-if={!averagePrice} className="three-column-price-qi">起</Text>
              </Text>
              <Text x-if={originalPrice && actualPrice !== originalPrice} className="three-column-original-price">¥{originalPrice}</Text>
            </View>

            <LinearGradient colors={['#FF7700', '#FF4B10']} start={{
            x: 0,
            y: 0
        }} end={{
            x: 1,
            y: 0
        }} className="three-column-buy-button">
              <Text className="three-column-buy-text">{buyText}</Text>
            </LinearGradient>
          </View>
        </View>
      </View>
    </Sensor>;
}
export default memo(ThreeColumnCard);
